e4.scrollReveal = {
    init: function () {
        var arrObservables = jQuery( e4.settings.scrollReveal.selector ).toArray();
        if ( e4.util.observer.isSupported === true && arrObservables.length > 0 ) {
            e4.util.observer.bind( arrObservables, e4.scrollReveal.bindObserver );
        }
    },
    bindObserver: function ( objEntry, objObserver ) {
        if ( objEntry.isIntersecting === true ) {
            e4.scrollReveal.reveal( objEntry.target );
            objObserver.unobserve( objEntry.target );
        }
        else {
            e4.scrollReveal.conceal( objEntry.target );
        }
    },
    conceal: function ( domElm ) {
        jQuery( domElm ).addClass( e4.settings.scrollReveal.classConceal );
    },
    reveal: function ( domElm ) {
        var jThis = jQuery( domElm );
        jThis.removeClass( e4.settings.scrollReveal.selector.substring( 1 ) );
        jThis.one( e4.settings.event.transitionend, function () {
            jThis.removeClass( [
                e4.settings.scrollReveal.classConceal,
                e4.settings.scrollReveal.classRevealFade,
                e4.settings.scrollReveal.classRevealSlide
            ].join( ' ' ) );
            jThis.addClass( e4.settings.scrollReveal.classRevealDone );
        } );
        jThis.addClass( e4.settings.scrollReveal.classRevealSlide );
    }
};
